import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Pages::Catalog @promos={{true}} />")